import styled from 'styled-components';
import Variables from "../../../assets/styleVariables";

export const NotificationsContainer = styled.div`
  position: relative;
  i.left-side-icon{
    &.pressed, &:hover{
      background-color: ${Variables.colors.complementary_300};
    }
  }
`;